export const getSalesclerks = (state, salesClerks) => {
  state.salesClerks = salesClerks
}

export const setLoading = (state, value) => {
  state.loading = value;
} 